import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchHrZonesAtArgs } from '../api/types/statsEntries.types';

import {
  fetchTrainingLevel,
  fetchHrZonesAt,
  fetchHrZones,
} from '../api/healthProfileStats.api';

export const statsHealthProfileQueryKeys = createQueryKeys(
  'statsHealthProfile',
  {
    fetchHrZones: {
      queryFn: () => fetchHrZones(),
      queryKey: null,
    },
    fetchHrZonesAt: (args: FetchHrZonesAtArgs) => ({
      queryFn: () => fetchHrZonesAt(args),
      queryKey: [args],
    }),
    fetchTrainingLevel: {
      queryFn: () => fetchTrainingLevel(),
      queryKey: null,
    },
  },
);
